import { getCloudFence, getFenceCar, addCloudFence, updateCloudFence, deleteCloudFence, getChoiceCar } from "../../api/config/modules/CloudFence";

const state = {
  getCloudFence: {},
  getFenceCar: {},
  addCloudFence: {},
  updateCloudFence: {},
  deleteCloudFence: {},
  getChoiceCar: {}
};

const mutations = {
  SET_GETCLOUDFENCE: (state, getCloudFence) => {
    state.getCloudFence = getCloudFence;
  },
  SET_GETFENCECAR: (state, getFenceCar) => {
    state.getFenceCar = getFenceCar;
  },
  SET_ADDCLOUDFENCE: (state, addCloudFence) => {
    state.addCloudFence = addCloudFence;
  },
  SET_UPDATECLOUDFENCE: (state, updateCloudFence) => {
    state.updateCloudFence = updateCloudFence;
  },
  SET_DELETECLOUDFENCE: (state, deleteCloudFence) => {
    state.deleteCloudFence = deleteCloudFence;
  },
  SET_GETCHOICECAR: (state, getChoiceCar) => {
    state.getChoiceCar = getChoiceCar;
  },
};

const actions = {
  GET_GETCLOUDFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getCloudFence(data)
        .then((res) => {
          commit("SET_GETCLOUDFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETFENCECAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getFenceCar(data)
        .then((res) => {
          commit("SET_GETFENCECAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_ADDCLOUDFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      addCloudFence(data)
        .then((res) => {
          commit("SET_ADDCLOUDFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATECLOUDFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateCloudFence(data)
        .then((res) => {
          commit("SET_UPDATECLOUDFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETECLOUDFENCE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteCloudFence(data)
        .then((res) => {
          commit("SET_DELETECLOUDFENCE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETCHOICECAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      getChoiceCar(data)
        .then((res) => {
          commit("SET_GETCHOICECAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
